/** Lucide icon names + emoji choices for the storefront "Why choose us" tiles. */
export const WHY_US_LUCIDE_NAMES = [
  "Truck",
  "ShieldCheck",
  "IndianRupee",
  "Headset",
  "Star",
  "Sparkles",
  "Award",
  "Heart",
  "Clock",
  "Package",
  "Leaf",
  "Zap",
  "Gift",
  "ThumbsUp",
  "BadgeCheck",
  "ShoppingBag",
  "Phone",
  "MapPin",
  "Thermometer",
  "Wind",
  "Droplets",
  "Shirt",
  "Snowflake",
  "Flame",
  "Recycle",
  "Waves",
];

export const ANNOUNCEMENT_LUCIDE_NAMES = [
  "Megaphone",
  "Bell",
  "Tag",
  "Percent",
  ...WHY_US_LUCIDE_NAMES,
];

export const WHY_US_EMOJIS = [
  "🚚", "🛡️", "💰", "🎧", "⭐", "✨", "🏆", "❤️",
  "⚡", "📦", "🌱", "🎁", "🛒", "🔒", "😊", "🇮🇳",
];

export function isWhyUsEmoji(value) {
  const v = String(value || "");
  return v.length > 0 && !/^[A-Za-z]+$/.test(v);
}
